
import {TaskUpdate, TaskUpdateType} from "@/models/task.update";

/**
 *
 * @class TaskBatchMeasureCreate
 *
 * incremental progress reporting on batch measure (final summary of a batch of batches)
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2022
 *
 */
export class TaskBatchMeasureCreate extends TaskUpdate {

  /** info to show to the user */
  public message: string;

  /** the icon to use */
  public icon:     string;

  /**
   * standard constructor, you have to uniquely identify the task progress stream (id)
   * and provide the type of progress update (type).
   *
   * @param id       the unique id of the task progress stream to clear (the context)
   * @param message  update text to show the user
   * @param progress estimate of progress
   *
   */
  constructor(id: string, message: string, progress: number) {

    super(id, TaskUpdateType.Progress, progress);

    this.message  = message;
    this.icon     = '/assets/images/big-query-icon-32.png';
  }

  /** subclasses that can render their own update should return non-empty HTML */
  render(): string {

    return `
<div class="task-file-upload-sub-panel">

  <div style="display: inline-block; width: 32px;">
    <img alt="creating model" class="tsp-icon" src="${this.icon}" width="32"></img>
  </div>

  <div style="display: inline-block; width: calc(100% - 40px); vertical-align: top; margin-top: 4px;">

    <div style="display: inline-block; ">
      <span class="tsp-label">${this.message}</span>
    </div>

    <div class="tsp-progress-border">
      <div class="tsp-progress-bar" style="width: ${this.progress.toFixed(2)}%"></div>
    </div>

  </div>

</div>
`;

  }


}
